<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content" v-loading="loadingStaus" :element-loading-text="loadingText">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-edit-outline"></i>
              <span v-if="$route.params.id">编辑内容</span>
              <span v-else>创建内容</span>
            </h1>
            <p class="page-subtitle">
              <span v-if="$route.path.indexOf('blog') !== -1">博客文章编辑</span>
              <span v-else-if="$route.path.indexOf('article') !== -1">新闻文章编辑</span>
              <span v-else>案例内容编辑</span>
            </p>
          </div>
        </div>

        <I18nLangBar
          v-model="contentLang"
          entity-type="article"
          :entity-id="formData.id || ''"
          :source-lang="sourceLang"
          :locales="contentLocales"
          @change="onContentLangChange"
          @translated="applyContentLangToForm" />

        <el-row :gutter="24">
          <el-form ref="articleForm" :model="formData" :rules="rules" label-width="120px" class="create-form">
            <!-- 左侧主要内容区域 -->
                <el-col :span="18" class="content-left">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-document"></i>
                    基本信息
                  </h3>
                </div>
                <div class="card-content">
                  <el-form-item label="标题" prop="title" class="form-item">
                    <div class="input-wrapper">
                      <el-input 
                        v-model="formData.title" 
                        placeholder="请输入文章标题"
                        size="large"
                        class="title-input">
                      </el-input>
                    </div>
                  </el-form-item>
                  
                  <el-form-item label="SEO 标题" prop="seo_title" class="form-item">
                    <div class="input-wrapper">
                      <el-input
                        v-model="formData.seo_title"
                        placeholder="请输入 SEO 标题（可空）"
                        class="keywords-input">
                      </el-input>
                    </div>
                  </el-form-item>

                  <el-form-item label="SEO 关键字" prop="seo_keywords" class="form-item">
                    <div class="input-wrapper">
                      <el-input 
                        v-model="formData.seo_keywords" 
                        placeholder="请输入关键字，多个关键字用逗号分隔"
                        class="keywords-input">
                      </el-input>
                    </div>
                  </el-form-item>

                  <el-form-item label="SEO 描述" prop="seo_description" class="form-item">
                    <div class="input-wrapper">
                      <el-input
                        type="textarea"
                        v-model="formData.seo_description"
                        placeholder="请输入 SEO 描述（可空）"
                        :rows="3"
                        class="excerpt-textarea">
                      </el-input>
                    </div>
                  </el-form-item>

                  <el-form-item label="SEO URL Slug" prop="seo_url_slug" class="form-item">
                    <div class="input-wrapper">
                      <el-input
                        v-model="formData.seo_url_slug"
                        placeholder="请输入 URL slug（可空）"
                        class="keywords-input">
                      </el-input>
                    </div>
                  </el-form-item>
                  
                  <el-form-item label="摘要" prop="excerpt" class="form-item">
                    <div class="input-wrapper">
                    <el-input
                      type="textarea"
                      v-model="formData.excerpt"
                        placeholder="请输入文章摘要"
                        :rows="4"
                        class="excerpt-textarea">
                      </el-input>
                    </div>
                  </el-form-item>
                  <el-form-item label="标签" prop="tags" class="form-item">
                    <div class="input-wrapper">
                      <el-input 
                        v-model="formData.tags" 
                        placeholder="请输入标签，多个标签用逗号分隔"
                        class="tags-input">
                      </el-input>
                    </div>
                  </el-form-item>
                </div>
              </div>

              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-edit"></i>
                    内容编辑
                  </h3>
                </div>
                <div class="card-content">
                  <el-form-item label="内容" prop="content" class="form-item content-item">
                    <div class="editor-wrapper">
                    <ApeEditor
                      :init-html="formData.content"
                      :editorHeight="480"
                        @handleTinymceInput="handleTinymceInput">
                      </ApeEditor>
                    </div>
                  </el-form-item>
                </div>
              </div>
                </el-col>
            
            <!-- 右侧配置区域 -->
                <el-col class="content-right" :span="6">
              <div class="sidebar-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-setting"></i>
                    文章设置
                  </h3>
                </div>
                <div class="card-content">
                  <el-form-item label="封面图片" prop="coverimage" class="form-item">
                    <div class="upload-wrapper">
                    <el-upload
                        class="cover-uploader"
                      action="/service/upload/image"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                      :limit="3"
                        :headers="uploadHeaders">
                        <div v-if="coverimage" class="cover-preview">
                          <img :src="coverimage" class="cover-image" />
                          <div class="cover-overlay">
                            <i class="el-icon-camera"></i>
                            <span>更换封面</span>
                          </div>
                        </div>
                        <div v-else class="upload-placeholder">
                        <i class="el-icon-plus"></i>
                          <div class="upload-text">上传封面</div>
                          <div class="upload-hint">支持JPG/PNG格式</div>
                      </div>
                    </el-upload>
                    </div>
                  </el-form-item>
                  
                  <el-form-item label="发布时间" prop="published_time" class="form-item">
                    <div class="input-wrapper">
                    <el-date-picker
                      v-model="formData.published_time"
                      type="datetime"
                        placeholder="选择发布时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                        class="datetime-picker">
                    </el-date-picker>
                    </div>
                  </el-form-item>
                  
                  <el-form-item label="状态" prop="article_status" class="form-item">
                    <div class="input-wrapper">
                      <el-select 
                        v-model="formData.article_status" 
                        placeholder="选择状态"
                        class="status-select">
                      <el-option label="启用" value="1"></el-option>
                      <el-option label="禁用" value="0"></el-option>
                    </el-select>
                    </div>
                  </el-form-item>

                  <el-form-item label="推荐到首页" prop="is_recommend" class="form-item">
                    <div class="switch-wrapper">
                      <el-switch
                        v-model="formData.is_recommend"
                        :active-value="'1'"
                        :inactive-value="'0'"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="是"
                        inactive-text="否">
                      </el-switch>
                    </div>
                  </el-form-item>
                </div>
              </div>

              <div class="action-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-check"></i>
                    操作
                  </h3>
                </div>
                <div class="card-content">
                  <div class="action-buttons">
                    <el-button
                      size="large"
                      type="primary"
                      class="save-btn"
                      :disabled="loadingStaus"
                      @click="saveConfirm">
                      <i class="el-icon-check" v-if="!loadingStaus"></i>
                      <i class="el-icon-loading" v-else></i>
                      <span v-if="!loadingStaus">保存发布</span>
                      <span v-else>保存中...</span>
                    </el-button>
                    
                    <el-button
                      size="large"
                      class="cancel-btn"
                      @click="returnList">
                      <i class="el-icon-back"></i>
                      返回列表
                    </el-button>
                  </div>
                  
                  <div class="tips-section">
                    <div class="tip-item">
                      <i class="el-icon-info"></i>
                      <span>建议标题控制在30字以内</span>
                    </div>
                    <div class="tip-item">
                      <i class="el-icon-info"></i>
                      <span>摘要建议100-200字</span>
                    </div>
                    <div class="tip-item">
                      <i class="el-icon-info"></i>
                      <span>封面建议尺寸 800x450</span>
                    </div>
                  </div>
                </div>
                  </div>
                </el-col>
              </el-form>
            </el-row>
          </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import { getApiKey } from '@/utils/apiKey';
import ApeUploader from "@/components/ApeUploader";
import ApeEditor from "@/components/ApeEditor";
import I18nLangBar from "@/components/I18nLangBar";
import i18nContentMixin from "@/mixins/i18nContentMixin";
import { mapGetters } from "vuex";


export default {
  components: {
    PageHeaderLayout,
    ApeUploader,
    ApeEditor,
    I18nLangBar,
  },
  mixins: [i18nContentMixin],
  data() {
    return {
      i18nEntityType: 'article',
      i18nFieldKeys: ['title', 'excerpt', 'content', 'tags', 'seo_title', 'seo_keywords', 'seo_description', 'seo_url_slug'],
      coverimage:'',
      filename: "",
      fileurl: "",
      uploadHeaders: {
        "x-api-key": getApiKey(),
        "Authorization":localStorage.getItem("Authorization")
      },
      activeTab: "0",
      hearTitle: "基本设置",
      activeName: 'cn',
      loadingStaus: true,
      loadingText: "玩命提交中……",
      articleId: 0, // 新闻id，0表示创建，非零为编辑
      // element的cascader的props值
      cascaderProps: {
        label: "display_name",
        value: "id",
      },
      searchCategoryCondition: {
        current_page: 1,
        page_size: 200,
        query: "name=?",
        params: ["category_article"],
      },
      searchCategoryLabelCondition: {
        current_page: 1,
        page_size: 200,
        query: "name=?",
        params: ["category_label"],
      },
      // 分类列表
      categoryList: [],
      // 标签
      categoryLabelList: [],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList: {
        cn: [],
        cht: [],
        en: []
      },
      // 已选中标签
      selectedLabelList: {
        cn: [],
        cht: [],
        en: []
      },
      // 新闻基本信息表单结构
      formData: {
        seo_title: null,
        seo_keywords: '',
        seo_description: null,
        seo_url_slug: '',
        is_recommend: '0',
        article_status: '1',
      },
      lang:'en',
      // 已上传图片列表
      uploadFileList:{
        cn:[],
        en:[],
        cht:[]
      },
      rules: {
        title: { required: true, message: "输入新闻名称", trigger: "blur" },
        seo_keywords: { required: true, message: "输入SEO 关键字", trigger: "blur" },
        excerpt: { required: true, message: "输入新闻摘要", trigger: "blur" },
        content: { required: true, message: "输入新闻内容", trigger: "blur" },
        tags: { required: true, message: "输入标签", trigger: "blur" },
      },
    };
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    handleAvatarSuccess(res) {
      if (this.$apiSuccess(res)){
        if (res.data.startsWith("http")){
          this.coverimage = res.data;
        }else if (res.data.startsWith("/")){
          this.coverimage = window.location.origin + res.data;
        }else{
          this.coverimage = window.location.origin  + "/" + res.data;
        }
        this.formData.cover_url = this.coverimage
      }else{
        this.$message.error(res.message)
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 返回列表
    returnList() {
      if (this.$route.path.indexOf('blog') != -1){
        this.$router.push("/cms/blog");
      }
      if (this.$route.path.indexOf('article') != -1){
        this.$router.push("/cms/article");
      }
      if (this.$route.path.indexOf('case') != -1){
        this.$router.push("/cms/case");
      }
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs["articleForm"].validate((valid) => {
        if (valid) {
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
      return true;
    },
    // 新闻相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true;
      try {
        if (this.formData.id && !this.isEditingSourceLang()) {
          await this.saveLocalizedFields()
          this.$message.success('译文已保存')
          this.loadingStaus = false
          return
        }
        let url = '/service/ola_app_article/create'
        if (this.formData.id == undefined || this.formData.id == ""){
            this.formData.article_type = this.$route.path.indexOf('blog') != -1 ? 1 : this.$route.path.indexOf('article') != -1 ? 2 : 3
        }else{
           url = '/service/ola_app_article/update'
        }
        let res = await this.$api.post(url,this.formData)
        if (this.$apiSuccess(res)) {
          this.$message.success('保存成功!')
          this.returnList()
        }else{
          this.$message.error(res.message)
        }
      } catch (e) {
        this.$message.error((e && e.message) ? e.message : '保存失败')
      }
      this.loadingStaus = false; 
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.cover = file.id;
      this.uploadFileList = fileList;
    },
    // 图片上传自定义验证
    apeUploaderVerify(rule, value, callback) {
      if (rule.required && !this.formData.cover) {
        callback(new Error(rule.message));
      }
      callback();
    },
    // 处理编辑器内容输入
    handleTinymceInput(val) {
      this.formData.content = val;
    },
   
    async initArticleForm() {
      if (this.$route.params.id) {
        let res = await this.$api.post('/service/ola_app_article/detail',{id:this.$route.params.id});
        if (this.$apiSuccess(res)) {
          const detail = res.data.detail
          if (detail.is_recommend == null || detail.is_recommend === '') {
            detail.is_recommend = '0'
          } else {
            detail.is_recommend = String(detail.is_recommend)
          }
          this.captureSourceSnapshot(detail, this.i18nFieldKeys)
          this.contentLang = this.sourceLang
          this.coverimage = detail.cover_url
          await this.applyContentLangToForm()
        }else{
          this.$message.error(res.message)
        }
      }
    },
  },
  async mounted() {
    this.loadingStaus = true;
    await this.loadI18nMeta()
    this.contentLang = this.sourceLang
    await this.initArticleForm();
    this.$nextTick(() => {
      this.loadingStaus = false;
    });
  },
};
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0
  
// 页面标题区域
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  padding 32px
  margin-bottom 24px
  border-radius 12px
  color #fff
  
  .title-content
    .page-title
      font-size 28px
      font-weight 600
      margin 0 0 8px 0
      display flex
      align-items center
      gap 12px
      
      i
        font-size 32px
        opacity 0.9
        
    .page-subtitle
      font-size 16px
      opacity 0.9
      margin 0

// 表单样式
.create-form
  .content-left
    .form-card
      background #fff
      border-radius 12px
      padding 24px
      margin-bottom 24px
      box-shadow 0 2px 12px rgba(0,0,0,0.1)
      border 1px solid #f0f0f0
      
      .card-header
        margin-bottom 20px
        padding-bottom 12px
        border-bottom 1px solid #f0f0f0
        
        .card-title
          font-size 18px
          font-weight 600
          color #303133
          margin 0
          display flex
          align-items center
          gap 8px
          
          i
            color #409EFF
            
      .card-content
        .form-item
          margin-bottom 24px
          
          &.content-item
            margin-bottom 0
            
          /deep/ .el-form-item__label
            font-weight 500
            color #606266
            
          .input-wrapper
            .title-input
              /deep/ .el-input__inner
                font-size 16px
                height 48px
                border-radius 8px
                border 2px solid #f0f0f0
                transition all 0.3s ease
                
                &:focus
                  border-color #409EFF
                  box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                  
            .keywords-input
              /deep/ .el-input__inner
                border-radius 8px
                border 2px solid #f0f0f0
                transition all 0.3s ease
                
                &:focus
                  border-color #409EFF
                  box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                  
            .excerpt-textarea
              /deep/ .el-textarea__inner
                border-radius 8px
                border 2px solid #f0f0f0
                transition all 0.3s ease
                resize vertical
                
                &:focus
                  border-color #409EFF
                  box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                  
          .editor-wrapper
            border 2px solid #f0f0f0
            border-radius 8px
            overflow hidden
            transition all 0.3s ease
            
            &:hover
              border-color #d4e6ff

// 右侧边栏样式
.content-right
  .sidebar-card, .action-card
    background #fff
    border-radius 12px
    padding 20px
    margin-bottom 20px
    box-shadow 0 2px 12px rgba(0,0,0,0.1)
    border 1px solid #f0f0f0
    
    .card-header
      margin-bottom 16px
      padding-bottom 10px
      border-bottom 1px solid #f0f0f0
      
      .card-title
        font-size 16px
        font-weight 600
        color #303133
        margin 0
        display flex
        align-items center
        gap 8px
        
        i
          color #409EFF
          
    .card-content
      .form-item
        margin-bottom 20px
        
        &:last-child
          margin-bottom 0
          
        /deep/ .el-form-item__label
          font-weight 500
          color #606266
          font-size 14px
          
        .input-wrapper
          .datetime-picker, .status-select
            width 100%
            
            /deep/ .el-input__inner
              border-radius 8px
              border 2px solid #f0f0f0
              transition all 0.3s ease
              
              &:focus
                border-color #409EFF
                box-shadow 0 0 0 2px rgba(64,158,255,0.1)

// 上传组件样式
.upload-wrapper
  .cover-uploader
    /deep/ .el-upload
      width 100%
      border none
      
    .cover-preview
      position relative
      width 100%
      height 200px
      border-radius 8px
      overflow hidden
      cursor pointer
      transition all 0.3s ease
      
      &:hover
        transform scale(1.02)
        
        .cover-overlay
          opacity 1
          
      .cover-image
        width 100%
        height 100%
        object-fit cover
        
      .cover-overlay
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        background rgba(0,0,0,0.6)
        display flex
        flex-direction column
        align-items center
        justify-content center
        color #fff
        opacity 0
        transition all 0.3s ease
        
        i
          font-size 24px
          margin-bottom 8px
          
        span
          font-size 14px
          
    .upload-placeholder
      width 100%
      height 200px
      border 2px dashed #d9d9d9
      border-radius 8px
      display flex
      flex-direction column
      align-items center
      justify-content center
      color #8c939d
      cursor pointer
      transition all 0.3s ease
      
      &:hover
        border-color #409EFF
        color #409EFF
        
      i
        font-size 32px
        margin-bottom 8px
        
      .upload-text
        font-size 16px
        font-weight 500
        margin-bottom 4px
        
      .upload-hint
        font-size 12px
        color #c0c4cc

// 操作按钮样式
.action-buttons
  margin-bottom 20px
  
  .save-btn
    width 100%
    height 44px
    background linear-gradient(135deg, #67C23A 0%, #85CE61 100%)
    border none
    border-radius 8px
    font-size 16px
    font-weight 600
    color #fff
    margin-bottom 12px
    transition all 0.3s ease
    box-shadow 0 4px 12px rgba(103,194,58,0.3)
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 6px 16px rgba(103,194,58,0.4)
      
    &:disabled
      background #e4e7ed
      color #c0c4cc
      box-shadow none
      transform none
      cursor not-allowed
      
  .cancel-btn
    width 100%
    height 40px
    border 2px solid #f0f0f0
    border-radius 8px
    color #606266
    background #fff
    font-weight 500
    transition all 0.3s ease
    
    &:hover
      border-color #409EFF
      color #409EFF

// 提示信息样式
.tips-section
  padding-top 16px
  border-top 1px solid #f0f0f0
  
  .tip-item
    display flex
    align-items center
    gap 8px
    margin-bottom 8px
    font-size 13px
    color #909399
    
    &:last-child
      margin-bottom 0
      
    i
      font-size 14px
      color #E6A23C

// 左侧内容区样式优化
.content-left
  padding-right 12px
  
  .form-card
    &:last-child
      margin-bottom 0

// 右侧边栏优化
.content-right
  padding-left 12px
  
  .sidebar-card
    position sticky
    top 20px
    
  .action-card
    position sticky
    top 240px

// 响应式设计
@media (max-width: 1200px)
  .content-left
    padding-right 8px
    
  .content-right
    padding-left 8px

@media (max-width: 768px)
  .page-title-section
    padding 20px
    
    .title-content
      .page-title
        font-size 24px
        
  .create-form
    .content-left, .content-right
      padding 0
      
    .form-card, .sidebar-card, .action-card
      padding 16px
      
    .sidebar-card, .action-card
      position static
      top auto
      
  .upload-wrapper
    .cover-preview, .upload-placeholder
      height 160px

@media (max-width: 480px)
  .page-title-section
    .title-content
      .page-title
        font-size 20px
        
  .action-buttons
    .save-btn
      height 40px
      font-size 14px
      
    .cancel-btn
      height 36px
      font-size 14px
</style>
